export default function KeywordBadge({ keyword }: { keyword: string }) {
  return (
    <span className={`badge bg-quaternary text-body-tertiary`} key={'keyword-badge-' + keyword}>
      #{keyword}
    </span>
  );
}
